module.exports = __webpack_public_path__ + "assets/c7fef86df9bacb3c2e1f3e3ac732ec5e.mp3";